var exports = {
  "k": "xcc377c0b--1d22e4--container",
  "U": "xcc377c0b--1d22e4--arrow",
};

module.exports = exports;
